(() => {
  function init() {
    const root = document.querySelector('.sova-collection-search-results') || document.getElementById('snize_results');
    if (!root) return;
    if (root.hasAttribute('data-sova-catalog-state')) {

      const error = root.querySelector('.sova-catalog-error');
      let queued = false;
      let timeout;
      function reveal() {
        if (queued) return;
        const results = root.querySelector('#snize_results');
        if (!results) return;
        const empty = results.querySelector('.snize-no-products-found, .snize-no-results, .snize-search-results-no-results');
        if (!results.querySelector('li.snize-product') && !empty) return;
        queued = true;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          root.dataset.sovaReservedHeight = String(Math.round(root.getBoundingClientRect().height));
          root.dataset.sovaCatalogState = 'ready';
          root.dataset.sovaRenderedHeight = String(Math.round(root.getBoundingClientRect().height));
          root.setAttribute('aria-busy', 'false');
          if (error) error.hidden = true;
          clearTimeout(timeout);
          readyObserver.disconnect();
        }));
      }
      const readyObserver = new MutationObserver(reveal);
      readyObserver.observe(root, {childList:true, subtree:true});
      timeout = setTimeout(() => {
        root.dataset.sovaCatalogState = 'error';
        root.setAttribute('aria-busy', 'false');
        if (error) error.hidden = false;
      }, 15000);
      root.querySelector('.sova-catalog-retry')?.addEventListener('click', () => location.reload());
      reveal();
    }
    const processed = new WeakSet();
    function prepare(image) {
      if (processed.has(image)) return;
      const card = image.closest('li.snize-product');
      const grid = card && card.parentElement;
      if (!grid || !grid.classList.contains('snize-search-results-content')) return;
      processed.add(image);
      const index = Array.from(grid.children).indexOf(card);
      const columns = window.matchMedia('(max-width:749px)').matches ? 2 :
        window.matchMedia('(max-width:989px)').matches ? 4 : 5;
      image.decoding = 'async';
      if (index >= 0 && index < columns) {
        image.loading = 'eager';
        image.fetchPriority = index === 0 ? 'high' : 'auto';
      }
    }
    function scan(node) {
      if (node.nodeType !== 1) return;
      if (node.matches('img.snize-item-image')) prepare(node);
      node.querySelectorAll('img.snize-item-image').forEach(prepare);
    }
    scan(root);
    new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(scan));
    }).observe(root, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
